import React, { Component } from 'react';
import './index.css';
import age_logo from './images/age-logo.png';



export default class Header extends Component {
    state = {
        showAge: false,//用于控制适龄信息的开关，在style中使用
    }


    //绑定适龄提醒信息图片的点击事件，开启适龄提醒
    showAgeWarn = () => {
        this.setState({ showAge: true });
    }

    //绑定适龄提醒具体信息的点击事件，关闭适龄提醒
    closeAgeWarn = () => {
        this.setState({ showAge: false });
    }

    videoPlay = () => {
        const v = document.getElementById('v1');
        v.setAttribute("muted", "true");
        v.play()
    }


    //移动端适配
    isMobile() {
        return !!navigator.userAgent.match(
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i
        );
    }
    render() {

        return (
            <div className='header-part'>
                {
                    //若为移动端，则放置gif；若为PC端，则放置原视频
                    this.isMobile() ? <img src='//dl.gamdream.com/idfe-MonumentValley-website/test.21905dc9.gif' id="v1-pic" /> :
                        <video muted id="v1" loop autoPlay controls={false} src='//dl.gamdream.com/idfe-MonumentValley-website/test.ec05c39b.mp4' />
                }

                {/* 适龄提醒 */}
                <div className='age-logo' onClick={this.showAgeWarn}>
                    <img src={age_logo} />
                </div>

                {/* 点击适龄提醒图片后弹出的适龄提醒 */}
                <div className='age-warn' onClick={this.closeAgeWarn} style={{ display: this.state.showAge ? 'block' : 'none' }}>
                    <div
                        style={{ display: 'flex', width: '100%', height: '100%', position: 'fixed', zIndex: '2147483647', top: '0px', left: '0px', backgroundColor: 'rgba(0, 0, 0, 0.8)', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ width: '800px', height: '490px', borderRadius: '24px', background: 'white', paddingBottom: '40px' }}>
                            <iframe
                                src="//tsf-pro-1251001060.cos.ap-guangzhou.myqcloud.com/MS/11574/iDreamSkyGames/AgeTips.html"
                                style={{ width: '100%', height: '100%', borderRadius: '24px', border: 'none' }} userSelect='none'>
                            </iframe>
                            <div
                                style={{ width: '60px', height: '60px', margin: '55px auto', cursor: 'pointer', background: 'url(&quot;//dl.gamdream.com/website/cbtn.png&quot;) no-repeat' }} userSelect='none'>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 左上信息 */}
                <div className='logo' onClick={this.videoPlay}>
                    <img src='//dl.gamdream.com/idfe-MonumentValley-website/logo.3111280f.png' />
                </div>

                <div className='downloadMsg'>
                    {/* 下载按钮旁边的信息 */}
                    <img src='//dl.gamdream.com/idfe-MonumentValley-website/msg.4f86d66a.png' />

                    <div>
                        {/* 下载按钮 */}
                        <a className='download-button' href='//dl.uu.cc/upgrade/jnbg/2.5.5/monumentkv_LEDOU_LEDOU_v2.5.5_s3.18.2_LE0S0N00000_202307111729.apk' />
                    </div>

                </div>

                {/*下载按钮的突出渐变层 */}
                <div className='gradual'>
                    <img src='//dl.gamdream.com/idfe-MonumentValley-website/gradual.84e5eca3.png' />
                </div>


            </div>
        )
    }
}

